export default __webpack_public_path__ + "static/media/6.3605e3f0.png";